import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';
import { CustomerAccountBusinessLogicService } from '../../../services/customer-account-business-logic.service';
import { RootScopeService } from '../../../services/root-scope.service';

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.scss']
})
export class DynamicContentComponent implements OnInit {
  @Input('cardData') cardData: any;

  /**
   * Build as a part of story -CCR1-5583
   * Update as a part of story - CCR1-10173
   */
  constructor(public custAccSerice: CustomerAccountBusinessLogicService,
    public rootScope: RootScopeService) { }

  ngOnInit(): void {
  }

  /**
   * This method is used to check if the cardData is empty or not
   * Refreshes the client info card data for the active customer tab.
   * Invokes the service to fetch the latest client info card data.
   */
  onRefreshClickAction() {
    console.log("method onRefreshClickAction called ")
    this.custAccSerice.getClientInfoCardData(this.rootScope.activeCustTab.clientId, true);
  }


  /** 
   * This method is used to get the greeting message for the service center
   * @param greeting - The greeting message template
   * @param serviceCenterName - The name of the service center
   * @return The formatted greeting message
   * */
  getGreeting(greeting, serviceCenterName) {
    greeting = greeting?.replaceAll('<<ServiceCenterName>>', serviceCenterName);
    greeting = greeting?.replaceAll('<<AgentName>>', this.rootScope.firstName);
    if (this.rootScope.activeCustTab?.tabData?.tabData?.firstName)
      greeting = greeting?.replaceAll('<<ParticipantFirstName>>', this.rootScope.activeCustTab?.tabData?.tabData?.firstName);

    if (this.rootScope.activeCustTab?.tabData?.tabData?.lastName)
      greeting = greeting?.replaceAll('<<ParticipantLastName>>', this.rootScope.activeCustTab?.tabData?.tabData?.lastName);

    return greeting;

  }
  /**
   * Below method check if there is any Default service is Pinned for the selected client
   * @returns Boolean
   */
  checkDefaultPinService(): boolean {
    const clientId = this.rootScope.activeCustTab?.clientId;
    const defaultService = this.rootScope.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId]?.service;
    const cardService = this.cardData?.parsedObjectData?.Service;

    return defaultService === cardService;
  }

  /**
   * Below method invoke on hollow/ grey pin icon to make it default service and
   * this method update the default service in the server. 
   * @param service 
   */
  makeDefaultService(service: any) {
    const clientId = this.rootScope.activeCustTab?.clientId;
    this.custAccSerice.updateClientInfoCardDefaultService(clientId, service);
  }
}
